import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import WhatsAppButton from "./components/site/WhatsAppButton";
import RouteSeo from "./components/site/RouteSeo";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import Fleet from "./pages/Fleet";
import About from "./pages/About";
import Guide from "./pages/Guide";
import GuideArticle from "./pages/GuideArticle";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import PaymentResult from "./pages/PaymentResult";
import { Faq, Legal, Admin } from "./pages/Misc";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./lib/lang";
import RoutePage from "./pages/RoutePage";
import LandingPage from "./pages/LandingPage";
import SEO_CONTENT from "./seo-content.json";
import { api } from "./lib/api";
import { applyContent, loadCachedContent, cacheContent } from "./lib/content";

const cached = loadCachedContent();

// Loads Admin-edited texts/photos; re-renders only if they changed since the cached copy.
const useSiteContent = () => {
  const [ver, setVer] = useState(0);
  useEffect(() => {
    api.get("/content").then(({ data }) => {
      if (JSON.stringify(data) === JSON.stringify(cached)) return;
      applyContent(data); cacheContent(data); setVer((v) => v + 1);
    }).catch(() => {});
  }, []);
  return ver;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  const ver = useSiteContent();
  return (
    <LangProvider key={ver}>
      <BrowserRouter>
        <ScrollTop />
        <RouteSeo />
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/airport-transfers" element={<ServicePage kindOverride="airport" />} />
              <Route path="/transfers/airport" element={<Navigate to="/airport-transfers" replace />} />
              <Route path="/destinations" element={<Navigate to="/" replace />} />
              <Route path="/transfers/:kind" element={<ServicePage />} />
              <Route path="/chauffeur" element={<ServicePage kindOverride="chauffeur" />} />
              <Route path="/tours" element={<Tours />} />
              <Route path="/tours/:slug" element={<TourDetail />} />
              {SEO_CONTENT.routes.map((r) => <Route key={r.slug} path={`/${r.slug}`} element={<RoutePage slug={r.slug} />} />)}
              {Object.keys(SEO_CONTENT.landings).map((p) => <Route key={p} path={p} element={<LandingPage path={p} />} />)}
              {Object.entries(SEO_CONTENT.redirects).map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/about" element={<About />} />
              <Route path="/corfu-guide" element={<Guide />} />
              <Route path="/corfu-guide/:slug" element={<GuideArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/book" element={<Booking />} />
              <Route path="/payment/success" element={<PaymentResult mode="success" />} />
              <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/legal/:page" element={<Legal />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
        <Toaster position="top-center" />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
